import gql from 'graphql-tag';

const CREATE_SALESFORCE_CONTACT = gql`
  mutation CreateSalesforceContact($data: SalesforceContactInput!) {
    createSalesforceContact(data: $data)
  }
`;

export default CREATE_SALESFORCE_CONTACT;
